module.exports = __webpack_public_path__ + "static/ucla-79b01f455b0b766d25c3a80c1ad48be1.png";